import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Heading from "../../../../Common/Components/Heading";
import { toast } from 'react-toastify';

import Add from '@mui/icons-material/Add';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Delete from '@mui/icons-material/Delete';
import { Button, IconButton } from "@mui/material";

import axios from "axios";
import url from "../../../../Common/URL";
import LoadingSpinner from "../../../../Common/Components/LoadingSpinner";

import StringToTime from "../../../../Common/Functions/StringDateTime";
import { useConfirm } from 'material-ui-confirm';
import MaterialReactTable from 'material-react-table';
import { useSelector } from "react-redux";


const BatchTable = () => {
  const confirm = useConfirm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    uname: sessionStorage.getItem("username"),
  });

  const Columns = useMemo(
    () => [
      { header: 'Batch', accessorKey: 'batch_name' },
      { header: 'Day of Week', accessorKey: 'day_of_week' },
      { header: 'Timing', accessorKey: 'time_of_day', accessorFn: rowData => StringToTime(rowData.time_of_day) },
      { header: 'Location', accessorFn: rowData => rowData.location_name.split("*")[0] },
    ],
    [],
  );
  const [data, setData] = useState([]);


  // ------------------------Fetching Batch table's data-------------------------------------
  useEffect(() => {
    loadBatches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadBatches = async () => {
    const obj = { uname: state.uname };
    await axios.post(url + "fetch_batches", obj)
      .then((response) => {
        // console.log(response)
        if (response.data.success) {
          let a = response.data.data;
          // console.log(a);
          !a.length ? setData([]) : setData(a);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
        }
      })
      .catch((err) => console.log(err));
  };
  // ------------------------Deleting Batch table's data-------------------------------------

  const onDelete = (id, resolve) => {
    const delObj = {
      id: id,
      uname: state.uname,
      tokenId: 123,
    };
    axios.post(url + "delete_batch", delObj)
      // .then((res) => console.log(res) )
      .then((res) => {
        resolve();
      })
      .catch((err) => console.log(err));
  };


  return (
    <>
      <div className={useSelector(state => state.sidebar.value) ? 'widthWhenSidebarOpen' : 'widthWhenSidebarClose'}>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb Breadcrumb align-items-center">
            <li className="breadcrumb-item"><Link to="/bulletin">Home</Link></li>
            <li className="breadcrumb-item">Setup</li>
            <li className="breadcrumb-item active" aria-current="page">Batch List</li>
          </ol>
        </nav>

        <Heading name="Batch List" />

        <div className="container-fluid mb-5">
          <div className="row my-4">
            <div className="col-12 mx-auto d-flex justify-content-end">
              <Button variant='contained' onClick={() => navigate("/add-batch")} >Add Batch <Add /></Button>
            </div>
          </div>
          <div className="row ">
            <div className="col-12 mx-auto">
              <MaterialReactTable
                state={{ isLoading: loading }}

                columns={Columns}
                data={data}
                enableRowNumbers
                enableRowSelection
                initialState={{ density: 'compact' }}
                enableDensityToggle={false}

                getRowId={(originalRow) => originalRow.batch_id}
                muiTableBodyRowProps={({ row }) => ({
                  onClick: (event) => navigate("/view-batch/" + row.id),
                  sx: { cursor: 'pointer' },
                })}

                renderTopToolbarCustomActions={({ table }) => (
                  <Button variant="contained" color="error" startIcon={<Delete />}
                    disabled={table.getSelectedRowModel().rows.length ? false : true}
                    onClick={() => {
                      confirm({ title: "Delete Confirmation", description: 'This will delete selected data permanently.' })
                        .then(() => {
                          let selectedRows = table.getSelectedRowModel().rows;
                          // console.log(selectedRows);
                          const delPromise = selectedRows.map((row) => {
                            return new Promise((resolve, reject) => {
                              onDelete(row.id, resolve);
                            });
                          });
                          Promise.all(delPromise).then(() => {
                            loadBatches();
                            table.resetRowSelection();
                            toast.info(selectedRows.length + " Row(s) Deleted!");
                          });
                        });
                    }}
                  >Delete
                  </Button>
                )}
              />

            </div>
          </div>

        </div>
      </div>

    </>
  );

};
export default BatchTable




